<template>
	<div class="product">
		<div class="search-order">
			<div class="el-search vue-top-padding radius">
				<el-row :gutter="20">
					<el-col :span="24">
						<div class="el-right">
							<el-form
								ref="order"
								:model="search"
								:inline="true"
								label-width="10px"
								size="small"
								class="demo-form-inline el-input-height"
							>
								<el-form-item prop="dateTime">
									<el-date-picker
										v-model="dateTime"
										type="datetimerange"
										format="yyyy-MM-dd HH:mm:ss"
										value-format="yyyy-MM-dd HH:mm:ss"
										:picker-options="pickerOptions"
										:default-time="['00:00:00', '23:59:59']"
										range-separator="-"
										:start-placeholder="$t('searchOrder.start')"
										:end-placeholder="$t('searchOrder.end')"
									>
									</el-date-picker>
								</el-form-item>
								<el-form-item prop="equipmentNo">
									<el-input
										v-model="search.equipmentNo"
										:placeholder="$t('inventoryLog.equipmentNo')"
									></el-input>
								</el-form-item>
								<el-form-item prop="aisleNo">
									<el-input
										v-model="search.aisleNo"
										:placeholder="$t('inventoryLog.aisleNo')"
									></el-input>
								</el-form-item>
								<el-form-item prop="goodsName">
									<el-input
										v-model="search.goodsName"
										:placeholder="$t('inventoryLog.goodsNameHolder')"
									></el-input>
								</el-form-item>
								<el-form-item prop="userName">
									<el-input
										v-model="search.userName"
										:placeholder="$t('inventoryLog.userNameHolder')"
									></el-input>
								</el-form-item>
								<el-form-item prop="source">
									<el-select
										v-model="search.source"
										:no-data-text="$t('common.noData')"
										:no-match-text="$t('common.noData')"
										clearable
										:placeholder="$t('inventoryLog.sourceHolder')"
									>
										<el-option
											:label="$t('inventoryLog.sourceWeb')"
											:value="0"
										></el-option>
										<el-option
											:label="$t('inventoryLog.sourceMachine')"
											:value="1"
										></el-option>
										<el-option
											:label="$t('inventoryLog.sourcePhone')"
											:value="2"
										></el-option>
									</el-select>
								</el-form-item>
								<el-form-item>
									<el-button
										type="primary"
										@click="onSubmit"
										icon="el-icon-search"
										>{{ $t("common.search") }}</el-button
									>
									<el-button @click="resetSearch()" icon="el-icon-refresh">{{
										$t("common.reset")
									}}</el-button>
								</el-form-item>
							</el-form>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="logList"
				:cell-class-name="cellClassName"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="userAccount"
					:label="$t('inventoryLog.userAccount')"
					width="160"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="equipmentNo"
					:label="$t('inventoryLog.equipmentNo')"
					width="150"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="aisleNo"
					:label="$t('inventoryLog.aisleNo')"
					width="90"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="goodsBefore"
					:label="$t('inventoryLog.goodsBefore')"
					width="140"
					class-name="product-cell"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="goodsAfter"
					:label="$t('inventoryLog.goodsAfter')"
					width="140"
					class-name="product-cell"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="inventoryBefore"
					:label="$t('inventoryLog.inventoryBefore')"
					width="120"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="inventoryAfter"
					:label="$t('inventoryLog.inventoryAfter')"
					width="120"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="maxInventory"
					:label="$t('inventoryLog.maxInventory')"
					width="110"
					:align="'center'"
					:formatter="maxInventoryFormat"
				></el-table-column>
				<el-table-column
					prop="priceBefore"
					:label="$t('inventoryLog.priceBefore')"
					width="110"
					:align="'center'"
					:formatter="(row) => priceFormat(row.priceBefore)"
				></el-table-column>
				<el-table-column
					prop="priceAfter"
					:label="$t('inventoryLog.priceAfter')"
					width="110"
					:align="'center'"
					:formatter="(row) => priceFormat(row.priceAfter)"
				></el-table-column>
				<el-table-column
					prop="source"
					:label="$t('inventoryLog.source')"
					width="120"
					:align="'center'"
					:formatter="sourceFormat"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:formatter="(row) => $formatDate(row.createTime)"
					:label="$t('inventoryLog.time')"
					width="160"
					:align="'center'"
				></el-table-column>
			</el-table>
			<el-pagination
				v-if="page.totalSize > 0"
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				@size-change="sizeChange"
				:page-size="page.pageSize"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	name: "InventoryLog",
	components: {},
	props: {
		// 传入设备号时只展示该设备的日志（设备列表弹窗场景）
		equipmentNo: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			dateTime: "",
			search: {
				equipmentNo: this.equipmentNo,
				aisleNo: "",
				goodsName: "",
				userName: "",
				source: "",
				startTime: "",
				endTime: "",
			},
			loading: false,
			page: {
				pageSize: 10,
				pageIndex: 1,
				totalSize: 0,
			},
			logList: [],
			pickerOptions: {
				shortcuts: [
					{
						text: this.$t("TimeControl.week"),
						onClick(picker) {
							const end = new Date();
							end.setHours(23, 59, 59, 999);
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.month"),
						onClick(picker) {
							const end = new Date();
							end.setHours(23, 59, 59, 999);
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.year"),
						onClick(picker) {
							const end = new Date();
							end.setHours(23, 59, 59, 999);
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit("pick", [start, end]);
						},
					},
				],
			},
		};
	},
	mounted() {
		this.currentChange();
	},
	methods: {
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		// 格式化价格
		priceFormat(price) {
			return price == null ? "" : this.$currency(price);
		},
		// 最大库存：有变化时显示 前 → 后（旧数据无变更前值，只显示当前值）
		maxInventoryFormat(row) {
			if (row.maxInventoryBefore != null && this.isChanged(row.maxInventoryBefore, row.maxInventory)) {
				return row.maxInventoryBefore + " → " + row.maxInventory;
			}
			return row.maxInventory == null ? "" : row.maxInventory;
		},
		// 判断变更（都为空视为无变化，仅一边为空视为有变化）
		isChanged(before, after) {
			if (before == null && after == null) {
				return false;
			}
			if (before == null || after == null) {
				return true;
			}
			return String(before) !== String(after);
		},
		// 高亮有变化的单元格
		cellClassName({ row, column }) {
			switch (column.property) {
				case "goodsAfter":
					return this.isChanged(row.goodsBefore, row.goodsAfter) ? "cell-changed" : "";
				case "inventoryAfter":
					return this.isChanged(row.inventoryBefore, row.inventoryAfter) ? "cell-changed" : "";
				case "priceAfter":
					return this.isChanged(row.priceBefore, row.priceAfter) ? "cell-changed" : "";
				case "maxInventory":
					return row.maxInventoryBefore != null && this.isChanged(row.maxInventoryBefore, row.maxInventory) ? "cell-changed" : "";
				default:
					return "";
			}
		},
		// 格式化修改渠道
		sourceFormat(row) {
			if (row.source === 0) {
				return this.$t("inventoryLog.sourceWeb");
			}
			if (row.source === 1) {
				return this.$t("inventoryLog.sourceMachine");
			}
			if (row.source === 2) {
				return this.$t("inventoryLog.sourcePhone");
			}
			return "";
		},
		// 加载日志列表
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.InventoryLog.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.logList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		// 提交查询搜索
		onSubmit() {
			if (this.dateTime && this.dateTime.length > 0) {
				this.search.startTime = this.dateTime[0];
				this.search.endTime = this.dateTime[1];
			} else {
				this.search.startTime = "";
				this.search.endTime = "";
			}
			this.page.pageIndex = 1;
			this.currentChange();
		},
		// 重置条件
		resetSearch() {
			this.dateTime = "";
			this.search.equipmentNo = this.equipmentNo;
			this.search.aisleNo = "";
			this.search.goodsName = "";
			this.search.userName = "";
			this.search.source = "";
			this.search.startTime = "";
			this.search.endTime = "";
			this.currentChange();
		},
	},
};
</script>

<style scoped>
.el-tag--mini {
	margin-right: 5px;
}
</style>

<style>
/* 高亮有变化的单元格（el-table 内部渲染，需非 scoped） */
.el-table td.cell-changed {
	background-color: var(--vtm-warn-soft);
	color: var(--vtm-warn);
	font-weight: bold;
}
/* 商品名最多显示两行，超出省略 */
.el-table td.product-cell .cell {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
	white-space: normal;
	word-break: break-word;
}
</style>
